import { memoizeReactConfig } from "@omnia/shared/react/reactDirective";
import { defineDirective, IOmniaShell, OmniaModuleId, str } from "./omnia"
import { IDashboardService } from "./types"
import { StocksCard } from "./stocks/StocksCard"
import { NvzCard } from "./nvz/NvzCard";
import { HoldingCard } from "./holding/HoldingCard";
import { WarningsCard } from "./warnings/WarningsCard";
import { CropsCard } from "./crops/CropsCard";
import { SeedPlansCard } from "./plans/SeedPlansCard";
import { NutritionPlansCard } from "./plans/NutritionPlansCard";

export class DashboardCtrl extends omnia.shell.Module {

    static create() {

        return defineDirective(DashboardCtrl, "app/dashboard/dashboard.html");

    };


    static $inject = ["$scope", "OmniaDashboardService", "OmniaShell"];
    
    holdingComponent = memoizeReactConfig(HoldingCard, () => {
        return {
            svc: this.dashboardSvc,
            shell: this.shell,
            session: this.session,
            // this field is added only for Angular to be able to detect changes and trigger re-render the React component
            stateVersion: this.dashboardSvc.stateVersion
        }
    })

    nvzComponent = memoizeReactConfig(NvzCard, () => {
        return {
            svc: this.dashboardSvc,
            shell: this.shell,
            session: this.session,
            // this field is added only for Angular to be able to detect changes and trigger re-render the React component
            stateVersion: this.dashboardSvc.stateVersion
        }
    })

    stocksComponent = memoizeReactConfig(StocksCard, () => {
        /** This object will be passed as props to the 'StocksCard' React component */
        return {
            svc: this.dashboardSvc,
            shell: this.shell,
            // this field is added only for Angular to be able to detect changes and trigger re-render the React component
            stateVersion: this.dashboardSvc.stateVersion
        }
    })

    warningsComponent = memoizeReactConfig(WarningsCard, () => {
        return {
            svc: this.dashboardSvc,
            shell: this.shell,
            // this field is added only for Angular to be able to detect changes and trigger re-render the React component
            stateVersion: this.dashboardSvc.stateVersion
        }
    })

    cropsComponent = memoizeReactConfig(CropsCard, () => {
        return {
            svc: this.dashboardSvc,
            shell: this.shell,
            // this field is added only for Angular to be able to detect changes and trigger re-render the React component
            stateVersion: this.dashboardSvc.stateVersion
        }
    })

    seedPlansComponent = memoizeReactConfig(SeedPlansCard, () => {
        return {
            svc: this.dashboardSvc,
            shell: this.shell,
            // this field is added only for Angular to be able to detect changes and trigger re-render the React component
            stateVersion: this.dashboardSvc.stateVersion
        }
    })

    nutritionPlansComponent = memoizeReactConfig(NutritionPlansCard, () => {
        return {
            svc: this.dashboardSvc,
            shell: this.shell,
            // this field is added only for Angular to be able to detect changes and trigger re-render the React component
            stateVersion: this.dashboardSvc.stateVersion
        }
    })

    constructor($scope: ng.IScope, private dashboardSvc: IDashboardService, shell: IOmniaShell) {

        super($scope, shell, "icon-holding-dashboard", str.Modules.Dashboard, OmniaModuleId.Dashboard)

    }

    $onInit() {
        this.refresh()
    }

    refresh() {
        return this.dashboardSvc.refresh()
    }

}
